import constants from 'app/constants'
import { LOCAL_STORAGE } from 'app/localStorageManager'
import { ERROR_CODE } from 'app/util/errorCodes'
import fetchJSONData from 'app/util/fetchJSONData'
import { API_ERROR_RESPONSE_MESSAGE, API_RESPONSE } from './constants'
import getSignature from './getSignature'

/**
 * Create an account with an access code
 *
 * @param {object} formData - the form data
 * @param {object} signer - the signer info
 * @returns {object?} the result or null if failed
 */
const createWithSignature = async (formData, signer) => {
  const signature = await getSignature(formData.wallet, signer)

  if (!signature) {
    // Fail
    return null
  }

  const { data, success } = await fetchJSONData(
    `${constants.API_URL}/customer/access_code`,
    {
      method: 'POST',
      body: JSON.stringify({
        ...formData,
        network: constants.NETWORK
      }),
      headers: {
        'Content-Type': 'application/json',
        'X-Signature': signature
      },
      credentials: 'include'
    }
  )

  if (!success) {
    throw new Error('Failed to sign up')
  }

  if (data?.token) {
    // Has token, add it to local storage
    localStorage.setItem(LOCAL_STORAGE.userTokenCache, data.token)
  }

  return data
}

/**
 * Submit a sign up with an access code
 *
 * @param {string} accessCode - the access code
 * @param {Function} getSigner - the signer method
 * @returns {object} the result
 */
const submitSignUpAccessCode = async (accessCode, getSigner) => {
  let res

  try {
    const signer = await getSigner()

    res = await createWithSignature(accessCode, signer)
  } catch (e) {
    console.error(e)
  }

  if (!res) {
    return {
      success: false,
      message: ERROR_CODE.UNKNOWN
    }
  }

  if (res?.message === API_RESPONSE.SIGNED_UP) {
    return {
      success: true,
      ...res
    }
  }

  return {
    success: false,
    message: API_ERROR_RESPONSE_MESSAGE[res?.message] || ERROR_CODE.UNKNOWN
  }
}

// Export
export default submitSignUpAccessCode
